/* eslint-disable react/prop-types */
import React from "react"
import { formatDate } from "utils/form-data"
import { numberFormat } from "utils/thousand-separator"
import logoKmi from "assets/logo-kmi.jpg"

// helper buat cek apakah dokumen tertentu ada di detail
function hasDoc(detail, label) {
  const docs = detail?.documents || []
  return docs.some((d) => d.documentName === label)
}

function ReceiptOfInvoicePrint({ data, classes }) {
  return (
    <div className={classes.printPageBlock}>
      {/* Header company + logo */}
      <div className={classes.printHeader}>
        <img src={logoKmi} alt="KMI Logo" className={classes.printLogo} />
        <div className={classes.printCompanyInfo}>
          <div style={{ fontWeight: "bold" }}>
            PT. KYORAKU KANTO MOULD INDONESIA
          </div>
          <div>Karawang International Industrial City (KIIC)</div>
          <div>Jl. Maligi VI Lot L-1 Karawang 41361</div>
          <div>Jawa Barat - Indonesia</div>
          <div>Phone : (62-267) 647173, Fax : (62-267) 647172</div>
        </div>
      </div>

      {/* Title */}
      <div className={classes.printTitleCenter}>TANDA TERIMA INVOICE</div>

      {/* Nama customer */}
      <div className={classes.printCustomerRow}>
        Nama Customer:&nbsp;
        <span style={{ fontWeight: "bold" }}>
          {data?.customer?.name || "-"}
        </span>
      </div>

      {/* Tabel ROI */}
      <table className={classes.printTable}>
        <thead>
          <tr>
            <th className={classes.printThTd} rowSpan={2}>
              No
            </th>
            <th className={classes.printThTd} rowSpan={2}>
              Nomor Invoice
            </th>
            <th className={classes.printThTd} rowSpan={2}>
              Tanggal Invoice
            </th>
            <th className={classes.printThTd} rowSpan={2}>
              Total Amount
            </th>
            <th
              className={classes.printThTd}
              colSpan={7}
              style={{ textAlign: "center" }}
            >
              Kelengkapan Dokumen
            </th>
          </tr>
          <tr>
            <th className={classes.printThTd}>FP Asli</th>
            <th className={classes.printThTd}>FP Copy</th>
            <th className={classes.printThTd}>Invoice Asli</th>
            <th className={classes.printThTd}>Invoice Copy</th>
            <th className={classes.printThTd}>GRN Asli</th>
            <th className={classes.printThTd}>DO Asli</th>
            <th className={classes.printThTd}>PO Copy</th>
          </tr>
        </thead>

        <tbody>
          {(data?.details || []).map((detail, index) => (
            <tr key={detail.idReceiptOfInvoiceDetail || index}>
              <td className={classes.printThTd}>{index + 1}</td>
              <td className={classes.printThTd}>
                {detail?.invoice?.invoiceNumber ?? "-"}
              </td>
              <td className={classes.printThTd}>
                {detail?.invoice?.date
                  ? formatDate(detail.invoice.date, true)
                  : "-"}
              </td>
              <td className={classes.printThTd}>
                <div className={classes.printRowTotalAmount}>
                  <span>{detail?.invoice?.currency?.code ?? "-"}</span>
                  <span>{numberFormat(detail?.totalAmount || 0)}</span>
                </div>
              </td>
              <td className={classes.printThTd}>
                {hasDoc(detail, "FP Asli") ? "√" : ""}
              </td>
              <td className={classes.printThTd}>
                {hasDoc(detail, "FP Copy") ? "√" : ""}
              </td>
              <td className={classes.printThTd}>
                {hasDoc(detail, "Invoice Asli") ? "√" : ""}
              </td>
              <td className={classes.printThTd}>
                {hasDoc(detail, "Invoice Copy") ? "√" : ""}
              </td>
              <td className={classes.printThTd}>
                {hasDoc(detail, "GRN Asli") ? "√" : ""}
              </td>
              <td className={classes.printThTd}>
                {hasDoc(detail, "DO Asli") ? "√" : ""}
              </td>
              <td className={classes.printThTd}>
                {hasDoc(detail, "PO Copy") ? "√" : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Footer buat TTD */}
      <table className={classes.printFooterTable}>
        <tbody>
          <tr>
            <td className={classes.printFooterCell} style={{ width: "40%" }}>
              <div
                className={classes.printFooterBox}
                style={{ marginRight: 8 }}
              >
                Tanggal Terima Invoice
              </div>
            </td>
            <td className={classes.printFooterCell} style={{ width: "30%" }}>
              <div style={{ textAlign: "center" }}>Diserahkan oleh :</div>
              <div className={classes.printSignLineWrapper}>
                <div className={classes.printSignLine} />
                <div>{data?.user?.name}</div>
              </div>
            </td>
            <td className={classes.printFooterCell} style={{ width: "30%" }}>
              <div style={{ textAlign: "center" }}>Diterima oleh :</div>
              <div className={classes.printSignLineWrapper}>
                <div className={classes.printSignLine} />
                <div>PIC Customer</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ReceiptOfInvoicePrint
